import { useRef, useState } from 'react'
import { toast } from 'react-toastify';
import usePayrollEssentials from 'hooks/usePayrollEssentials';
import { createPayGroup } from 'store/entities/payroll/payrollSetup/action';
import { ButtonLoader } from 'components/__new/common/form';
import useLoginInfo from 'hooks/useLoginInfo';
import logger from 'utils/logger';

const CreatePayGroup = () => {
    const submitRef = useRef(null)
    const {useSelector, dispatch, history, SubPageTooltip, lettersRegex } = usePayrollEssentials()
    const [form, setForm] = useState({});
    const { createPayGroupLoading: createLoading } = useSelector(state => state.entities.payrollSetup)
    const {userInfo} = useLoginInfo()

    const handleSubmit = (e) => {
        e.preventDefault()
        if(!form?.name?.length) {
            toast.error('Please enter a Pay Group name')
        } else if(!form?.description?.length) {
            toast.error('Please enter the Pay Group Description')
        } else if(!lettersRegex.test(form?.name)) {
            toast.error('Pay group name must contain letters')
        } else {
            logger("Employer-Payroll-setup-paygroups-create-success", userInfo);
            dispatch(createPayGroup(form))
            setTimeout(() => {
                history.push(`/payroll-configuration/pay-groups/assign`)
            }, 2000);
        }
    }

    const handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        setForm({...form, [name]: value})
    }

    return (
    <div className="w-full">
        <div className="border-b flex-btw items-center flex-wrap lg:flex-nowrap pb-3  mb-5 lg:mb-8">
            <div className="w-full lg:w-2/4">
                <div className="font-medium prl-bold flex items-center">
                    Create Pay Group
                    <SubPageTooltip
                        text={<span>This payroll setup is required for <br /> both Net Payroll and Gross Payroll.</span>}
                    />
                </div>
                <p className="mb-1 mt-1.5 text-xs lt-gray">Setup unique pay groups and add employees to them.</p>
            </div>
            <div className="payroll-setup-subpage-action">
                <ButtonLoader  onClick={() => submitRef?.current?.click()} loading={createLoading} type="button" className="btn btn-md btn-ep-primary">
                    {createLoading ? "Configuring" : "Continue"}
                </ButtonLoader>
                <button disabled={createLoading} onClick={() => history.push("/payroll-configuration/pay-groups")} className="btn btn-md btn-white bg-white ml-4 lg:ml-6">Cancel</button>
            </div>
        </div>
        <form onSubmit={handleSubmit} className="w-full">
            <div className="border-b w-full pt-7 lg:pt-0">
                <div className="structure-wrap">
                    <p className="structure-text">Name of Pay Group</p>
                    <div className="structure-input">
                    <input minLength={3} maxLength={50} required className="form-input" type="text" name='name'
                    placeholder="Enter Pay Group Name" onChange={handleChange} />
                    </div>
                </div>

                <div className="structure-wrap">
                    <p className="structure-text">Description of Pay Group</p>
                    <div className="structure-input">
                        <textarea style={{resize: "none"}} required rows="6" className="form-input-textarea"
                            placeholder='Enter description' onChange={handleChange} name='description' />
                    </div>
                </div>
                <button ref={submitRef} style={{display: 'none'}} type="submit">Continue</button>
            </div>
        </form>
    </div>
    )
}

export default CreatePayGroup